import { render, staticRenderFns } from "./I2SideBar.vue?vue&type=template&id=74b2edb2&scoped=true"
import script from "./I2SideBar.vue?vue&type=script&lang=js"
export * from "./I2SideBar.vue?vue&type=script&lang=js"
import style0 from "./I2SideBar.vue?vue&type=style&index=0&id=74b2edb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b2edb2",
  null
  
)

export default component.exports